'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicLayout = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getComponent2 = require('./getComponent');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function loop(arrOrMap, callback) {
  if (Array.isArray(arrOrMap)) {
    arrOrMap.forEach(callback);
  } else {
    for (var key in arrOrMap) {
      var item = arrOrMap[key];
      var newItem = { key: key };
      if (typeof item === 'function') {
        if (item.prototype && item.prototype.isReactComponent) {
          newItem.component = item;
        } else {
          newItem.getProps = item;
        }
      } else if (item === false) {
        newItem.props = false;
      } else {
        Object.assign(newItem, item);
      }
      callback(newItem);
    }
  }
}

var BasicLayout = exports.BasicLayout = (_temp = _class = function (_React$PureComponent) {
  _inherits(BasicLayout, _React$PureComponent);

  function BasicLayout() {
    _classCallCheck(this, BasicLayout);

    return _possibleConstructorReturn(this, (BasicLayout.__proto__ || Object.getPrototypeOf(BasicLayout)).apply(this, arguments));
  }

  _createClass(BasicLayout, [{
    key: 'getComponent',
    value: function getComponent(name) {
      return this.props.components[name] || _getComponent2.getComponent.emptyComponent;
    }
  }, {
    key: 'hasComponent',
    value: function hasComponent(name) {
      return this.props.components[name] && this.props.components[name] !== _getComponent2.getComponent.emptyComponent;
    }
  }]);

  return BasicLayout;
}(_react2.default.PureComponent), _class.getLayoutProps = function (option, viewContent) {
  option.__widgets__ = option.__widgets__ || {};
  var layoutProps = Object.assign({
    route: option.route,
    viewContent: viewContent,
    components: Object.assign({}, option.__widgets__),
    style: option.style
  }, option.props);
  var layoutBlocks = Object.assign({}, this.layoutBlocks);
  loop(option.components, function (item) {
    var Com = item.component || layoutBlocks[item.key];
    if (Com) {
      delete item.component;
      delete layoutBlocks[item.key];
      layoutProps.components[item.key] = layoutProps.components[item.key] || (0, _getComponent2.getComponent)(item.props, item.getProps)(Com);
      if (item.props && item.static) {
        option.__widgets__[item.key] = layoutProps.components[item.key];
      }
    }
  });
  for (var name in layoutBlocks) {
    layoutProps.components[name] = layoutProps.components[name];
    if (layoutBlocks[name].props && layoutBlocks[name].static) {
      option.__widgets__[name] = layoutProps.components[name];
    }
  }
  var customLayoutProps = this.displayName && option[this.displayName];
  for (var key in customLayoutProps) {
    if (key === 'components') {
      Object.assign(layoutProps.components, customLayoutProps[key]);
    } else {
      layoutProps[key] = customLayoutProps[key];
    }
  }
  return layoutProps;
}, _class.propTypes = {
  className: _propTypes2.default.string,
  components: _propTypes2.default.object,
  viewContent: _propTypes2.default.element,
  children: _propTypes2.default.element,
  style: _propTypes2.default.object
}, _class.defaultProps = {
  className: '',
  components: {}
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/layouts/basicLayout.jsx
// module id = 8
// module chunks = 0